import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-historia',
  templateUrl: './hero-historia.component.html',
  styleUrls: ['./hero-historia.component.scss']
})
export class HeroHistoriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
